import clsx from "clsx";

export function Card({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        "bg-white rounded-lg shadow-md p-6 max-w-full",
        className
      )}
    >
      {children}
    </div>
  );
}
